import { useGridMqttSubscription } from '@hooks/mqtt/useGridMqttSubscription';
import { Box, SxProps, Theme } from '@mui/material';
import {
  DataGridPro,
  DataGridProProps,
  GridApiPro,
  useGridApiRef,
} from '@mui/x-data-grid-pro';
import { MutableRefObject, memo } from 'react';
import { DeviceDataTableRow } from './types';

interface SingleViewDataGridProps {
  rows: DeviceDataTableRow[];
  boxStyles: SxProps<Theme>;
  gridProps: Omit<DataGridProProps, 'rows' | 'apiRef'>;
}

const SingleViewDataGrid: React.FC<SingleViewDataGridProps> = ({
  rows,
  boxStyles,
  gridProps,
}) => {
  const apiRef: MutableRefObject<GridApiPro> = useGridApiRef();

  useGridMqttSubscription(rows, apiRef);

  return (
    <Box sx={boxStyles}>
      <DataGridPro {...gridProps} rows={rows} apiRef={apiRef} />
    </Box>
  );
};

SingleViewDataGrid.displayName = 'SingleViewDataGrid';

export default memo(SingleViewDataGrid);
